/* eslint-disable max-len */
import React from 'react';
import { Container } from 'react-bootstrap';
import { BuyMeACoffeeIcon, EmailIcon, FacebookIcon } from './FeedBackIcons';


export function AboutPage() {
  return <Container>
    <h1>Sailing Handicap Calculator</h1>
    <p>This site provides a tool for producing a table of the handicap time differences for sail boat racing.</p>
    <p>This will you as a competitor to know where you are in relation to your competitors as a race progresses.</p>
    <p>There are several sections available from the menu:</p>
    <ul>
      <li>Table - view the list of time allowances between the boats in the current group</li>
      <li>Groups - manage groups of boats</li>
      <li>Boats - edit the list of boats and their respective handicaps within the currently selection group</li>
      <li>Import and Export to access the complete set of data for all the groups to be exported and imported between different devices</li>
    </ul>
    <p>The site uses browser local storage to persist the list of groups and boats so that the same data is available next time you return to the site on the same device</p>
    <p>If you find this site useful please consider making a donation <BuyMeACoffeeIcon/></p>
    <p>Got Feedback? <EmailIcon/> <FacebookIcon/>
    </p>
  </Container>;
}
